import styled from '@emotion/styled';

export const StyledMain = styled.main({
    position: 'relative',
    transition: 'all 0.5s ease-in-out',
    flexGrow: 1,
});

export const SkipLink = styled.a(({ theme }) => ({
    color: theme.colors.white,
    background: theme.colors.black,
    padding: theme.space[1],
    position: 'absolute',
    top: 10,
    left: 10,
    pointerEvents: 'none',
    opacity: 0,

    '&:focus-visible': {
        opacity: 1,
        pointerEvents: 'auto',
        boxShadow: theme.shadows.accessibility,
    },
    zIndex: 999,
}));
